<template>
  <b-container fluid class="examenes-conductor card p-2">
    <div class="page-header mb-4 bg-dark">
      <h1 class="page-title">
        <i class="fa-solid fa-clipboard-check text-primary mr-3"></i>
        Exámenes de Conductores
      </h1>
      <p class="page-subtitle">Registro y gestión de exámenes médicos y pruebas para conductores</p>
    </div>

    <!-- Formulario de Alcoholimetría -->
    <FormularioAlcoholimetria :tipo-identificaciones="tipoIdentificaciones" :results-exams="resultsExams"
      @submit="handleAlcoholimetriaSubmit" class="bg-dark rounded" />

    <!-- Formulario de Examen Médico -->
    <FormularioExamenMedico :tipo-identificaciones="tipoIdentificaciones" :results-exams="resultsExams"
      @submit="handleExamenMedicoSubmit" class="bg-dark rounded" />

    <!-- Formulario de Aptitud Física -->
    <FormularioAptitudFisica :tipo-identificaciones="tipoIdentificaciones" :results-exams="resultsExams"
      @submit="handleAptitudFisicaSubmit" class="bg-dark rounded" />

    <!-- Toast para notificaciones -->
    <b-toast id="success-toast" title="Éxito" variant="success" solid auto-hide-delay="5000">
      {{ successMessage }}
    </b-toast>

    <b-toast id="error-toast" title="Error" variant="danger" solid auto-hide-delay="5000">
      {{ errorMessage }}
    </b-toast>
  </b-container>
</template>

<script>
import FormularioAlcoholimetria from '../examenes/formulario-alcoholimetria.vue'
import FormularioExamenMedico from '../examenes/formulario-examen-medico.vue'
import FormularioAptitudFisica from '../examenes/formulario-aptitud-fisica.vue'
import Swal from 'sweetalert2'

export default {
  name: 'ExamenesConductor',
  components: {
    FormularioAlcoholimetria,
    FormularioExamenMedico,
    FormularioAptitudFisica
  },
  data() {
    return {
      tipoIdentificaciones: [],
      resultsExams: [
        { label: 'Aprobado', value: 'aprobado' },
        { label: 'No Aprobado', value: 'no_aprobado' },
        { label: 'Pendiente', value: 'pendiente' }
      ],
      successMessage: '',
      errorMessage: '',
      usuario: {}
    }
  },
  async mounted() {
    this.usuario = JSON.parse(localStorage.getItem('setPersonaAct') || '{}')
    await this.obtenerTiposIdentificacion()
  },
  methods: {
    async handleAlcoholimetriaSubmit(data) {
      try {
        const response = await this.$store.dispatch('hl_post_cookie', {
          path: 'ApiSuperTransporteTerminales/alcoholimetria',
          data: data
        })
        // Opcional: actualizar datos locales
        // this.allDataTerminals['Alcoholimetrias'].push(data)
        this.mostrarAlerta(response)

      } catch (error) {
        this.showErrorToast(error.message)
      }
    },

    async handleExamenMedicoSubmit(data) {
      try {
        const response = await this.$store.dispatch('hl_post_cookie', {
          path: 'ApiSuperTransporteTerminales/examen-medico',
          data: data
        })

        this.mostrarAlerta(response)

      } catch (error) {
        this.showErrorToast(error.message)
      }
    },

    async handleAptitudFisicaSubmit(data) {
      try {
        const response = await this.$store.dispatch('hl_post_cookie', {
          path: 'ApiSuperTransporteTerminales/aptitud-fisica',
          data: data
        })

        this.mostrarAlerta(response)

      } catch (error) {
        this.showErrorToast(error.message)
      }
    },

    async obtenerTiposIdentificacion() {
      try {
        const response = await this.$store.dispatch('hl_get_cookie', {
          path: 'ApiSuperTransporteGenerales/listar-tipo-identificaciones'
        })

        if (Array.isArray(response)) {
          this.tipoIdentificaciones = response.filter(item => item.estado === true)
        } else {
          console.warn('Formato de respuesta inesperado:', response)
        }
      } catch (error) {
        console.error('Error al obtener tipos de identificación:', error)
        this.showErrorToast('Error al cargar tipos de identificación')
      }
    },

    showSuccessToast(message) {
      this.successMessage = message
      this.$bvToast.show('success-toast')
    },

    showErrorToast(message) {
      this.errorMessage = message
      this.$bvToast.show('error-toast')
    },

    mostrarAlerta(response){
      if(response.codigoError){          
          Swal.fire({
          title: '¡Algo salio mal!',
          text: `Error: ${response.mensaje}`,
          icon: "warning"
        })
        }
        else{
          Swal.fire({
          title: '¡Éxito!',
          text: response.mensaje,
          icon: "success"
        })
        }
    }
  }
}
</script>

<style scoped>
.examenes-conductor {
  min-height: 100vh;
  padding: 2rem 0;
}

.page-header {
  text-align: center;
  margin-bottom: 3rem;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(75, 72, 72, 0.1);
}

.page-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.page-subtitle {
  font-size: 1.1rem;
  margin: 0;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .page-title {
    font-size: 2rem;
  }

  .page-subtitle {
    font-size: 1rem;
  }

  .examenes-conductor {
    padding: 1rem 0;
  }
}
</style>
